// extracted by mini-css-extract-plugin
export var attachment = "_qb-a";
export var emailContainer = "_qb-4";
export var emailContentPaddedContainer = "_qb-b";
export var emailHeader = "_qb-6";
export var emailIframe = "_qb-3";
export var emailInfoIcon = "_qb-9";
export var emailShortenedSummary = "_qb-e";
export var infoDropdown = "_qb-0";
export var infoRowBoundedContent = "_qb-d";
export var internal = "_qb-5";
export var merchant = "_qb-8";
export var messageInputContainer = "_qb-h";
export var normal = "_qb-7";
export var replyCard = "_qb-f";
export var subtleButton = "_qb-1";
export var subtleButtonIconContainer = "_qb-2";
export var toggleViewRepliesButton = "_qb-c";
export var wrappingText = "_qb-g";